function EnergetickeStrojeAZariadenia(){
    return(
        <div>
            EnergetickeStrojeAZariadenia
        </div>
    );
};

export default EnergetickeStrojeAZariadenia;